// custom typefaces
import "@fontsource-variable/montserrat"
import "@fontsource/merriweather"
// normalize CSS across browsers
import "./src/normalize.css"
// custom CSS styles
import "./src/style.css"

import React from "react"

import { LanguageProvider } from "./src/context/languageContext"

import { config } from "@fortawesome/fontawesome-svg-core"
import "@fortawesome/fontawesome-svg-core/styles.css"
import 'ckeditor5/ckeditor5.css';

// Highlighting for code blocks
import "prismjs/themes/prism.css"

import './src/styles/global.css'

config.autoAddCss = false

export const wrapRootElement = ({ element }) => {
  return <LanguageProvider>{element}</LanguageProvider>
}
